import { render, staticRenderFns } from "./FilteredActivities.vue?vue&type=template&id=71980768&scoped=true"
import script from "./FilteredActivities.vue?vue&type=script&lang=js"
export * from "./FilteredActivities.vue?vue&type=script&lang=js"
import style0 from "./FilteredActivities.vue?vue&type=style&index=0&id=71980768&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71980768",
  null
  
)

export default component.exports